import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToolbarService {

  private changesSub = new Subject<string>();

  changes(): Observable<string> {
    return this.changesSub.asObservable();
  }

  constructor() { }

  setTitle(title: string) {
    //this.title = title;
    this.changesSub.next(title);
  }
}
